<template>
  <div v-if="url != false">
    <span>
      <a :href="url" class="color-white" target="_blank">
        <i class="fas fa-cloud-download-alt color-black color-purple f20"></i>
      </a>
    </span>
  </div>
</template>

<script>
export default {
  props: ["id", "account_uid"],
  data: () => ({
    url: "",
    show: false,
  }),
  mounted() {
    this.makeURL();
  },
  watch: {
    id: function () {
      if (this.id) this.makeURL();
    },
  },
  methods: {
    makeURL() {
      let base = `/resume/${this.id}`;

      axios
        .get(this.account_uid ? `${base}/${this.account_uid}` : base)
        .then((response) => {
          this.url = response.data.url;
        });
    },
  },
};
</script>

<style lang="scss" scoped></style>
